module.exports = __webpack_public_path__ + "static/img/amp-lowgain.915ffe3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/amp-lowgain.png
// module id = +19E
// module chunks = 12